import {
  RETRIEVE_CARTS,
} from "../actions/types";

const initialState = { carts: [], totalCartCount: 0 };

const refundReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_CARTS:
      return {
        carts: payload.listCarts,
        totalCartCount: payload.count,
      };

    default:
      return state;
  }
};

export default refundReducer;